module.exports = __webpack_public_path__ + "pc/img/body_basic 9.969486d8.jpg";